$(document).ready(function(){
  
	// With BLOG  
  	//$(window).scroll(function() {
      //var wScroll = $(this).scrollTop();
      //var logo = $('.topnav_logo');
     // var blogStart = $('.home-blog-posts').position().top;
      //if(wScroll > (blogStart-100)) {
      //  logo.css('opacity', 1);
      //}
     // else {
     //   logo.css('opacity', 0);
     // }
    //});
  
  // No BLOG
  $(window).scroll(function() {
      var wScroll = $(this).scrollTop();
      var logo = $('.topnav_logo');
      var blogStart = $('.home-blog-posts').position().top;
      if(wScroll + $(this).height() == $(document).height()) {
        logo.css('opacity', 1);
      }
      else {
        logo.css('opacity', 0);
      }
    });
  
  	$("#pop").click(function () {
      	$('#popup').css('visibility' , 'visible' );
	});
  
});